<template>
  <CrudDataTable
    :con="con"
    :items="categories"
    sortBy="name"
    ref="dataTable"
  >
    <template v-slot:item.iconRepresentation="{ item }">
      <v-icon>{{ getEquipmentType(item) }}</v-icon>
    </template>

    <template v-slot:dialog-form="{ item }">
      <EditCategoryForm
        :con="con"
        :editedItem="item"
        @closed="closeEditDialog"
      />
    </template>
  </CrudDataTable>
</template>

<script>
import CrudDataTable from "../CrudDataTable";
import EditCategoryForm from "./EditCategoryForm";
import CrudCategoriesTable from "@/models/crud/CrudCategoriesTable";
import { mapActions } from "vuex";

export default {
  name: "CrudCategories",
  components: {
    CrudDataTable,
    EditCategoryForm,
  },
  props: {
    categories: null,
  },
  computed: {
    con() {
      const _con = {
        ...CrudCategoriesTable,
        crud: {
          indexOf: (item) => {
            return this.categories.indexOf(item);
          },
          create: (item) => {
            return this.addCategory(item);
          },
          update: (item) => {
            return this.editCategory(item);
          },
          delete: (item) => {
            return this.deleteCategory(item);
          },
        },
      };
      return _con;
    },
  },
  methods: {
    ...mapActions("categorieModule", [
      "addCategory",
      "editCategory",
      "deleteCategory",
    ]),
    getEquipmentType(item) {
      let path;
      if (item.name.includes("ECRAN")) {
        path = "mdi-monitor";
      } else if (item.name.includes("CLAVIER")) {
        path = "mdi-keyboard";
      } else if (item.name.includes("SOURIS")) {
        path = "mdi-mouse";
      } else if (item.name.includes("CASQUE")) {
        path = "mdi-headset";
      }else if (item.name.includes("POSTE")) {
        path = "mdi-desk";
      } else {
        path = "mdi-semantic-web";
      }
      return path;
    },
    closeEditDialog() {
      this.$refs.dataTable.closeEdit();
    },
  },
};
</script>
